export const SET_TOKEN_SUCCESS = 'SET_TOKEN_SUCCESS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const SET_USER_SUCCESS = 'SET_USER_SUCCESS'
export const SET_USER_FAVORITES = 'SET_USER_FAVORITES'
export const UPDATE_USER = 'UPDATE_USER'
export const BLOCK_SESSION = 'BLOCK_SESSION'
